import { Box } from "@mui/material";
import ProfileButton from "./ProfileButton";
import ThemeModeToggle from "./ThemeModeToggle";
import LanguageSwitcher from "./LanguageSwitcher";
import CollapseBtn from "./CollapseBtn";
import BuildingInfo from "./BuildingInfo";
import ProfileSettingsButton from "./ProfileSettingsButton";
import useLayout from "@/features/layout/useLayout";

const VerticalMenuFooter = () => {
  const { isSidebarCollapsed } = useLayout()
  return (
    <Box
      sx={{
        p: 1,
        borderTop: '1px solid',
        borderColor: 'divider',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
      }}
    >
      <BuildingInfo />
      {
        isSidebarCollapsed 
          ? <CollapsedProfileSettings /> 
          : <ProfileSettingsButton />
      }
      <CollapseBtn />
    </Box>
  )
}

const CollapsedProfileSettings = () => (
  <Box sx={{
    py: 1,
    px: 0.5,
    display: 'flex',
    gap: 1,
  }}>
    <ProfileButton  />
    <ThemeModeToggle  />
    <LanguageSwitcher  />
  </Box>
)

export default VerticalMenuFooter;